<template>
  <b-modal :id="modalId" :ref="modalId" :no-close-on-backdrop="!isCloseOnBackDrop" centered hide-header hide-footer>
    <div v-if="isShowXIcon" class="atom-modal--container-icon" @click="closeModal">
      <feather-icon class="atom-modal--icon" icon="XIcon" />
    </div>

    <div class="atom-modal--slot">
      <slot name="header"></slot>
      <slot name="body"></slot>
      <slot name="footer" :close="closeModal"></slot>
    </div>
  </b-modal>
</template>

<script>
import { BModal } from "bootstrap-vue"

export default {
  name: "AtomModal",
  components: {
    BModal,
  },
  props: {
    modalId: {
      type: String,
      required: true,
    },
    isCloseOnBackDrop:{
      type: Boolean,
      required: false,
      default: true
    },
    isShowXIcon:{
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits:["onClickCloseIcon"],
  methods: {
    closeModal() {
      this.$refs[this.modalId].hide()
      this.$emit("onClickCloseIcon");
    },
  },
}
</script>

<style lang="scss" scoped>
.atom-modal--container-icon {
  display: flex;
  justify-content: flex-end;
}
.atom-modal--icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.atom-modal--slot {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
